import { get, isObject, isArray } from 'lodash-es'
import { stringify } from 'qs'

import API_CONSTANTS from '@/js/helper/api-constants.js'

export const getLinkOfType = (links, type) => get(links, type)

export const getLinkUrlOfType = (links, type) => getLinkUrl(getLinkOfType(links, type))
export const getLinkAllowedOfType = (links, type) => getLinkAllowed(getLinkOfType(links, type))

export const getSelfLink = links => getLinkOfType(links, API_CONSTANTS.LINK.SELF)
export const getOptionsLink = links => getLinkOfType(links, API_CONSTANTS.LINK.OPTIONS)

export const getLinkUrl = link => (isObject(link) ? get(link, API_CONSTANTS.LINK.HREF) : link)
export const getLinkAllowed = link =>
  isObject(link) ? get(link, API_CONSTANTS.LINK.ALLOW) : undefined

export const hasAllowed = allowed => isArray(allowed)

export const setLinksTargetForQuery = (query, target = '_self') => {
  const allowedTargets = ['_self', '_blank', '_parent', '_top']

  if (allowedTargets.indexOf(target) < 0) {
    throw new Error(`target: ${target} not allowed`)
  }

  if (query && target) {
    Array.from(document.querySelectorAll(`${query} a`)).forEach(link => {
      link.setAttribute('target', target)
    })
  }
}

export const buttonLinkFromAttributes = attributes => ({
  url: get(attributes, API_CONSTANTS.CTA.PATHS.LINK_URL),
  target: get(attributes, API_CONSTANTS.CTA.PATHS.LINK_TARGET),
  title: get(attributes, API_CONSTANTS.CTA.PATHS.LINK_TITLE),
})

// export const typo3LinkProps = link => ({
//   url: get(link, API_CONSTANTS.CTA.LINK_URL),
//   target: get(link, API_CONSTANTS.CTA.LINK_TARGET),
//   title: get(link, API_CONSTANTS.CTA.LINK_TITLE),
// })

export const typo3LinkProps = link =>
  isObject(link)
    ? {
        url: get(link, API_CONSTANTS.CTA.LINK_URL),
        target: get(link, API_CONSTANTS.CTA.LINK_TARGET),
        title: get(link, API_CONSTANTS.CTA.LINK_TITLE),
      }
    : {
        url: link,
        target: undefined,
        title: undefined,
      }

export const typo3LinkUrl = link => (isObject(link) ? typo3LinkProps(link).url : link)

export const addGetParamToUrl = (link, params) => {
  const paramPrefix = /\?/.test(link) ? '&' : '?'
  return `${link}${paramPrefix}${stringify(params)}`
}
